const env = import.meta.env ?? {};

function isLocalHostname(hostname = "") {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

function resolveUrl(value = "", base = undefined) {
  try {
    return new URL(value, base);
  } catch {
    return null;
  }
}

export function resolveLocalBrowserUrl(rawUrl = "", location = null) {
  const normalizedRawUrl = String(rawUrl || "").trim();
  if (!normalizedRawUrl) {
    return "";
  }

  const resolvedUrl = resolveUrl(normalizedRawUrl);
  if (!resolvedUrl) {
    return normalizedRawUrl;
  }

  const locationHostname = String(location?.hostname || "").trim();
  if (!locationHostname || isLocalHostname(locationHostname) || !isLocalHostname(resolvedUrl.hostname)) {
    return resolvedUrl.toString();
  }

  const rewrittenUrl = new URL(resolvedUrl.toString());
  rewrittenUrl.hostname = locationHostname;
  return rewrittenUrl.toString();
}

const browserLocation = typeof window !== "undefined" ? window.location : null;
const siteUrl = resolveLocalBrowserUrl(env.VITE_SITE_URL?.trim() || "", browserLocation);
const supabaseUrl = resolveLocalBrowserUrl(env.VITE_SUPABASE_URL?.trim() || "", browserLocation);
const supabasePublishableKey = env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() || "";

export const supabaseConfig = Object.freeze({
  siteUrl,
  supabaseUrl,
  supabasePublishableKey,
});

export const isSupabaseConfigured = Boolean(
  supabaseConfig.supabaseUrl && supabaseConfig.supabasePublishableKey
);
